import { render, staticRenderFns } from "./ServiceFormDetail.vue?vue&type=template&id=4b61e6cc&scoped=true&"
import script from "./ServiceFormDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormDetail.vue?vue&type=style&index=0&id=4b61e6cc&scoped=true&lang=css&"
import style1 from "./ServiceFormDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61e6cc",
  null
  
)

export default component.exports